module.exports = __webpack_public_path__ + "static/media/chrome-logo.c5b6bcf2.svg";